import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle } from 'lucide-react';
import SEO from '../components/SEO';
import { FadeIn, PageHero } from '../components/PageComponents';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

const OpdrachtOpgevenPage = () => {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ company: '', contact: '', email: '', phone: '', role: '', duration: '', description: '' });
  const handleSubmit = (e) => { e.preventDefault(); setSubmitted(true); setTimeout(() => { setSubmitted(false); setForm({ company: '', contact: '', email: '', phone: '', role: '', duration: '', description: '' }); }, 3000); };

  return (
    <main className="pt-28 min-h-screen">
      <SEO title="Opdracht Opgeven - Staffing Force" description="Geef uw opdracht op bij Staffing Force. Wij leveren binnen 48-72 uur een geschikte interim finance of HR professional." keywords="opdracht opgeven, interim professional, finance, HR, staffing force" />
      <PageHero label="Voor opdrachtgevers" title="Opdracht Opgeven" description="Heeft u een interim professional nodig? Vul het formulier in en wij nemen binnen 24 uur contact met u op." image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1920&q=85&auto=format&fit=crop" />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          <FadeIn>
            <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100">
              {submitted ? (
                <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-16">
                  <CheckCircle size={48} className="text-[#00897B] mx-auto mb-4" />
                  <h2 className="text-2xl font-bold text-gray-900 mb-2">Opdracht ontvangen!</h2>
                  <p className="text-gray-600">Wij nemen binnen 24 uur contact met u op om de opdracht te bespreken.</p>
                </motion.div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2"><Label>Bedrijfsnaam *</Label><Input required value={form.company} onChange={e => setForm({...form, company: e.target.value})} placeholder="Uw bedrijfsnaam" className="h-11 border-gray-200" /></div>
                    <div className="space-y-2"><Label>Contactpersoon *</Label><Input required value={form.contact} onChange={e => setForm({...form, contact: e.target.value})} placeholder="Uw naam" className="h-11 border-gray-200" /></div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2"><Label>E-mail *</Label><Input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="email@bedrijf.nl" className="h-11 border-gray-200" /></div>
                    <div className="space-y-2"><Label>Telefoon</Label><Input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="+31 6 1234 5678" className="h-11 border-gray-200" /></div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2"><Label>Gewenste rol *</Label>
                      <Select value={form.role} onValueChange={v => setForm({...form, role: v})}>
                        <SelectTrigger className="h-11 border-gray-200"><SelectValue placeholder="Selecteer een rol" /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="controller">Financial Controller</SelectItem>
                          <SelectItem value="business-controller">Business Controller</SelectItem>
                          <SelectItem value="cfo">Interim CFO</SelectItem>
                          <SelectItem value="finance-manager">Finance Manager</SelectItem>
                          <SelectItem value="hr-bp">HR Business Partner</SelectItem>
                          <SelectItem value="payroll">Payroll Specialist</SelectItem>
                          <SelectItem value="duurzaamheid">Duurzaamheidsconsultant</SelectItem>
                          <SelectItem value="overig">Overig</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="space-y-2"><Label>Geschatte duur</Label>
                      <Select value={form.duration} onValueChange={v => setForm({...form, duration: v})}>
                        <SelectTrigger className="h-11 border-gray-200"><SelectValue placeholder="Duur opdracht" /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="1-3">1-3 maanden</SelectItem>
                          <SelectItem value="3-6">3-6 maanden</SelectItem>
                          <SelectItem value="6-12">6-12 maanden</SelectItem>
                          <SelectItem value="12+">12+ maanden</SelectItem>
                          <SelectItem value="vast">Vast dienstverband</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                  <div className="space-y-2"><Label>Omschrijving opdracht *</Label><Textarea required value={form.description} onChange={e => setForm({...form, description: e.target.value})} placeholder="Beschrijf de opdracht, gewenste ervaring en eventuele bijzonderheden..." rows={5} className="border-gray-200 resize-none" /></div>
                  <button type="submit" className="bg-[#00897B] hover:bg-[#00796B] text-white px-8 py-3 rounded font-semibold text-sm transition-all hover:-translate-y-0.5 flex items-center gap-2"><Send size={16} />Opdracht versturen</button>
                </form>
              )}
            </div>
          </FadeIn>
        </div>
      </section>
    </main>
  );
};

export default OpdrachtOpgevenPage;
